"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isServiceSalesOrderItem = void 0;
const TSalesOrderItemType_1 = require("../types/TSalesOrderItemType");
const isServiceSalesOrderItem = (item, serviceProductId) => item.type === TSalesOrderItemType_1.TSalesOrderItemType.Fixed &&
    item.productId === serviceProductId;
exports.isServiceSalesOrderItem = isServiceSalesOrderItem;
//# sourceMappingURL=isServiceSalesOrderItem.js.map